export default {
  "Sivut": "Sider",
  "Ei luokiteltu": "Ukategorisert",
  "Viimeiset 8 viikkoa": "Siste 8 uker",
  "Vie palautteet": "Eksporter tilbakemeldinger",
  "Ulkoasuasetukset": "Utseendeinnstillinger",
  "Logo": "Logo",
  "Väri": "Farge",
  "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "Logoen må være en PNG-fil med gjennomsiktig bakgrunn.",
  "Ei logoa": "Ingen logo",
  "Valitse logo": "Velg logo",
  "Logon tulee olla PNG-tiedosto.": "Logoen må være en PNG-fil.",
  "Tiedosto on liian suuri (max 5 MB).": "Filen er for stor (maks 5 MB).",
  "Logon tausta tulee olla läpinäkyvä.": "Logoens bakgrunn må være gjennomsiktig.",
  "Tiedostoa ei voitu lukea kuvana.": "Filen kunne ikke leses som et bilde.",
  "Logon tallennus epäonnistui.": "Lagring av logoen mislyktes.",
  "Poista logo": "Fjern logo",
  "Logon poistaminen epäonnistui.": "Fjerning av logoen mislyktes.",
  "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "Skjermlogoen erstatter firmalogoen på denne skjermen. Bildet trenger ikke å være kvadratisk.",
  "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "Hovedfargen brukes på appens knapper, overskrifter og fremhevinger.",
  "Esikatselu": "Forhåndsvisning",
  "Esimerkki": "Eksempel",
  "Painike": "Knapp",
  "Värin tallennus epäonnistui.": "Lagring av fargen mislyktes.",
  "Pääkäyttäjät": "Hovedbrukere",
  "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Bare hovedbrukere kan legge til eller fjerne andre hovedbrukere.",
  "Näytä loki": "Vis logg",
  "Lisää pääkäyttäjä": "Legg til hovedbruker",
  "Ei pääkäyttäjiä": "Ingen hovedbrukere",
  "Et voi poistaa itseäsi pääkäyttäjistä": "Du kan ikke fjerne deg selv fra hovedbrukere",
  "Viimeistä pääkäyttäjää ei voi poistaa": "Den siste hovedbrukeren kan ikke fjernes",
  "Poista pääkäyttäjistä": "Fjern fra hovedbrukere",
  confirm_remove_mainuser: "Er du sikker på at du vil fjerne brukeren {name} fra hovedbrukere? Brukeren forblir i systemet som en vanlig bruker.",
  "Hae käyttäjää": "Søk bruker",
  "Kirjoita nimi tai sähköposti": "Skriv navn eller e-post",
  "Ei tuloksia": "Ingen resultater",
  "Lisää pääkäyttäjäksi": "Legg til som hovedbruker",
  "Pääkäyttäjän lisääminen epäonnistui": "Kunne ikke legge til hovedbrukeren",
  "Pääkäyttäjien muutosloki": "Endringslogg for hovedbrukere",
  "Ei merkintöjä": "Ingen oppføringer",
  "Toiminto": "Handling",
  "Suoritti": "Utført av",
  "Pääkäyttäjän oikeudet lisätty": "Hovedbrukerrettigheter tildelt",
  "Pääkäyttäjän oikeudet poistettu": "Hovedbrukerrettigheter fjernet",

  "feedback_newview_info": "Vi fornyer tilbakemeldingshåndteringen! Prøv den nye visningen nedenfor. Det nye grensesnittet blir standard i fremtiden.",
  "Uusi näkymä": "Ny visning",
  "Ohjeet": "Instruksjoner",
  "Puhelinnumero": "Telefonnummer",
  "Pitkä vastaus": "Langt svar",
  "Lyhyt vastaus": "Kort svar",
  "Valitse yksi": "Velg én",
  "Takaisin": "Tilbake",
  "Saapuneet / luokka": "Innboks / kategori",
  "Vanha näkymä": "Gammel visning",
  "Päivitä": "Oppdater",
  "Näytä valmiit": "Vis fullførte",
  "Tieto ei näy palautteen lähettäjälle": "Vises ikke for den som sendte tilbakemeldingen",
  "Sisäinen otsikko": "Intern tittel",
  "Ei valmiita palautteita": "Ingen fullførte tilbakemeldinger",
  "Ei saapuneita palautteita": "Ingen innkommende tilbakemeldinger",
  "Ei käsittelyssä olevia palautteita": "Ingen tilbakemeldinger under behandling",
  "Näytä infotv näytöillä": "Vis på Infotv-skjermer",
  "Lomake": "Skjema",
  "Ei käytössä": "Ikke i bruk",
  "Käytä mukautettua lomaketta": "Bruk tilpasset skjema",
  "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Deaktiver tilbakemeldingstypen og lagre endringer for å redigere skjemafelt",
  "Sisältö": "Innhold",
  "Asetukset": "Innstillinger",
  "Lataa ja lisää": "Last opp og legg til",
  "Näyttö": "Skjerm",
  "Toissijainen sisältö (30%)": "Sekundært innhold (30%)",
  "Pääsisältö (70%)": "Hovedinnhold (70%)",
  "Alatunnisteen tekstit": "Bunntekster",
  "Lisää teksti": "Legg til tekst",
  "Näytöt": "Skjermer",
  "Ulkoasu": "Utseende",
  "Sää": "Vær",
  "Näytön sisällönhallinta": "Innholdsstyring for skjerm",
  "Asettelu": "Layout",
  "Haluatko varmasti poistaa sisällön näytöltä?": "Er du sikker på at du vil fjerne innholdet fra skjermen?",
  "Jaettu asettelu (70% / 30%)": "Delt layout (70% / 30%)",
  "Koko leveys": "Full bredde",
  "Tumma tila": "Mørk modus",
  "Näytä alatunniste": "Vis bunntekst",
  "Sisällön näyttöaika (sekuntia)": "Innholdsvisningstid (sekunder)",
  "Valitse kirjastosta": "Velg fra biblioteket",
  "Ei hakutuloksia": "Ingen søkeresultater",
  "Ei kuvia kirjastossa": "Ingen bilder i biblioteket",
  "Lisää näytölle": "Legg til på skjermen",
  "Virhe lisättäessä sisältöä": "Feil ved adding av innhold",
  "kohdetta": "elementer",
  "Lisää": "Legg til",
  "Lataa kuva": "Last opp bilde",
  "Kirjastosta": "Fra biblioteket",
  "Uutiset": "Nyheter",
  "Tapahtumat": "Hendelser",
  "Lisää sisältöä yllä olevilla painikkeilla": "Legg til innhold ved å bruke knappene ovenfor",
  "aktiivista uutista.": "aktive nyheter.",
  "Näytetään max 5 uusinta uutista": "Viser maks 5 siste nyheter",
  "Ei aktiivisia uutisia": "Ingen aktive nyheter",
  "Ilmoittautuneet": "Påmeldte",
  "permanent_pages_info": "Permanente sider vises i Piiri-appen sin meny som egne seksjoner (for eksempel med tittelen Vårt selskap). Du kan opprette nye seksjoner hvis du vil gruppere innholdet på permanente sider i egne temaer som vises i menyen. En ny seksjon vises i menyen når appen startes på nytt eller nettlesersiden oppdateres",
  "Osio": "Seksjon",
  "Luo uusi osio": "Opprett ny seksjon",
  "Pysyvät sivut": "Permanente sider",
  "Uusi kyselytyökalu": "Nytt undersøkelsesverktøy",
  "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "Skjemaet har svar. Redigering er begrenset.",
  "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Merk: Skjemaet kan kun redigeres i begrenset grad etter at det har kommet inn svar.",
  "surveyinfo1": "Vi fornyer våre undersøkelser. Du kan prøve det nye verktøyet",
  "surveyinfo2": "Piiri mobilappen må oppdateres til den nye versjonen (1.15.0) for at undersøkelser opprettet med det nye undersøkelsesverktøyet skal være synlige for brukerne.",
  "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "Du har ikke tilgang til alle grupper i denne publikasjonen.",
  "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "Du kan se publikasjonen, men du kan ikke gjøre endringer.",
  "Oletus": "Standard",
  "Vie kaaviot kuvana": "Eksporter diagrammer som et bilde",
  "Suodattimet": "Filtre",
  "Tyhjennä": "Tøm",
  "Aikavyöhyke": "Tidssone",
  "Vastausvaihtoehto": "Svaralternativ",
  "Lisää vaihtoehto": "Legg til alternativ",
  "Tyhjä vaihtoehto": "Tomt alternativ",
  "Vaihtoehto": "Alternativ",
  "Vastausvaihtoehdot": "Svaralternativer",
  "Haluatko varmasti poistaa vastausvaihtoehdon?": "Er du sikker på at du vil slette svaralternativet?",
  "vastausta": "svar",
  "Ei vastauksia": "Ingen svar",
  "Kentällä ei ole otsikkoa": "Feltet har ingen tittel",
  "Klikkaa muokataksesi kenttää": "Klikk for å redigere feltet",
  "Ohjeteksti (valinnainen)": "Hjelpetekst (valgfritt)",
  "Päivämäärä": "Dato",
  "Pakollinen": "Obligatorisk",
  "Kentän otsikko": "Felttittel",
  "Tietotyyppi": "Datatype",
  "Vastausaika on pakollinen": "Svartid er obligatorisk",
  "Monirivinen teksti": "Flerlinjetekst",
  "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "Ingen spørsmål. Legg til det første spørsmålet fra venstre.",
  "Monivalinta": "Flervalg",
  "Valinta": "Valg",
  "Valitse vähintään yksi ryhmä": "Velg minst én gruppe",
  "Teksti": "Tekst",
  "Lisää kysymys": "Legg til spørsmål",
  "Lomakkeen kentät": "Skjema-felter",
  "Julkaise ryhmiin": "Publiser til grupper",
  "Kopioi kysely": "Kopier undersøkelse",
  "Tietoa Piiri-sovelluksesta": "Informasjon om Piiri-appen",
  "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "Gruppeansvarlig ser bare filer for gruppene de administrerer",
  "Sivu": "Side",
  "Lukukuittaus saatu": "Lesebekreftelse mottatt",
  "Ei lukukuittausta": "Ingen lesebekreftelse",
  "Raportti": "Rapport",
  "Lukukuittauksia ei ole käytössä": "Lesebekreftelser er ikke i bruk",
  "Versio": "Versjon",
  "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "Hvis du øker versjonsnummeret, vil brukerne bli bedt om en ny lesebekreftelse for innholdet",
  "Selite (valinnainen)": "Forklaring (valgfritt)",
  "Teksti näytetään käyttäjille kuittauksen yhteydessä": "Tekst som vises til brukerne ved bekreftelse",
  "Vaadi lukukuittaus": "Krev lesebekreftelse",
  "Muokkaa kansiota": "Rediger mappe",
  "Uusi kansio": "Ny mappe",
  "Uusi alikansio": "Ny undermappe",
  "tiedostoa": "filer",
  "Muokkaa": "Rediger",
  "Lukukuittaukset": "Lesebekreftelser",
  "Failed to submit acknowledgment. Please try again.": "Sending av bekreftelse mislyktes. Prøv igjen.",
  "Kuittaa luetuksi": "Marker som lest",
  "Lukukuittaus": "Lesebekreftelse",
  "Lukukuittaus vaaditaan": "Lesebekreftelse kreves",
  "Olet kuitannut tämän luetuksi": "Du har markert dette som lest",
  "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "Innholdet er oppdatert siden din forrige bekreftelse. Bekreft på nytt.",
  "Tämä sisältö vaatii lukukuittauksen.": "Dette innholdet krever lesebekreftelse.",
  "Your browser does not support the video tag.": "Nettleseren din støtter ikke videotaggen.",
  "Avaa linkki": "Åpne lenke",
  "Kaikki tiedostot": "Alle filer",
  "Kansio": "Mappe",
  "Avaa tiedosto": "Åpne fil",
  "Järjestys": "Rekkefølge",
  "Anna kansion nimi": "Oppgi mappenavn",
  "Kansion nimi": "Mappenavn",
  "Haluatko varmasti poistaa kansion?": "Er du sikker på at du vil slette mappen?",
  "Vie ilmoittautumiset": "Eksporter påmeldinger",
  "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "Nøkkelord kan brukes til å kategorisere og filtrere nyheter.",
  "Ryhmä on käytössä": "Gruppen er i bruk",
  "Ryhmä ei ole käytössä": "Gruppen er ikke i bruk",
  "DisableGroupInfo": "En gruppe kan merkes som inaktiv hvis den ikke har noen:\n- administrator\n- diskusjonskanal\n- 'Vårt selskap'-side (eller tilsvarende permanent side)\n\nSlik merker du en brukt gruppe som inaktiv:\n- Fjern gruppens administrative rettigheter i brukeradministrasjonen.\n- Merk diskusjonskanaler tilknyttet gruppen som inaktive.\n- Slett 'Vårt selskap'-sider laget for gruppen, eller flytt dem til en annen gruppe. Hvis en permanent side vises for flere grupper, er det nok å fjerne synligheten for gruppen som skal slettes.\n\nMerk!\nAnnet innhold opprettet for gruppen (nyheter, arrangementer, undersøkelser, filer) beholdes i Piiri selv når gruppen deaktiveres.",
  "Käyttäjä halitsee tietoa itse": "Brukeren administrerer informasjonen selv",
  "Käyttäjän kielivalinta": "Brukerens språkvalg",
  "Tiedoston maksimikoko on 10MB": "Maksimal filstørrelse er 10MB",
  "Peruuta": "Avbryt",
  "Avainsanat käytössä": "Nøkkelord i bruk",
  "Hae": "Søk",
  "Järjestä": "Sorter",
  "department-info": "Bruk av avdelinger er frivillig. Gruppering av personell i avdelinger er kun synlig i 'Hos oss'-seksjonen. Hvis selskapet grupperer personell i avdelinger, kan brukerne søke etter kontaktinformasjon etter avdeling.",
  "Oletusuutiskuva": "Standard nyhetsbilde",
  "Julkaisuasetukset": "Publiseringsinnstillinger",
  "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "Standard nyhetsbilde brukes i stedet for logo i nyheter hvis nyheten ikke har sitt eget bilde.",
  "Hae otsikolla": "Søk etter tittel",
  "Kysymys julkaistaan heti": "Spørsmålet publiseres umiddelbart",
  "Tapahtuma julkaistaan julkaisuaikana": "Arrangementet publiseres på publiseringstidspunktet",
  "Nimi on pakollinen kaikilla kielillä": "Navn er obligatorisk på alle språk",
  "Uusi osasto": "Ny avdeling",
  "Kaikki": "Alle",
  "Osastot": "Avdelinger",
  "Uusi ryhmä": "Ny gruppe",
  "Ryhmän nimi": "Gruppenavn",
  "Oma tila": "Egen status",
  "Yhteiset liitteet": "Felles vedlegg",
  "attachment_lang_tip": "Felles vedlegg er synlige for alle uavhengig av språkvalg. Vedlegg i språkversjoner er kun synlige for brukere med det aktuelle språkvalget.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Oversettelse fullført. Kontroller at oversettelsen er korrekt før du lagrer.",
  "Suorita käännös": "Utfør oversettelse",
  "Automaattinen käännös": "Automatisk oversettelse",
  "deepl_notice": "Innholdet oversettes ved hjelp av <a href='https://www.deepl.com/en/translator' target='_blank'>DeepL-tjenesten</a>. Vær oppmerksom på at teksten som skal oversettes sendes til DeepL-servere for behandling. Selskapet er ansvarlig for å sikre at det oversatte innholdet er korrekt og hensiktsmessig. Verktøyet er kun ment for oversettelse av Piiri-innhold",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Er du sikker på at du vil slette brukeren? Denne handlingen kan ikke angres!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Hvis du vil oppdatere bildet, må du først slette det eksisterende bildet",
  "ryhmää": "grupper",
  "Push-ilmoitukset käytössä": "Push-varslinger i bruk",
  "Kansikuvat": "Forsidebilder",
  "Ei kuvia, näytetään logo": "Ingen bilder, logo vises",
  "Lisää uusi kansikuva": "Legg til nytt forsidebilde",
  "Enintään 5 kuvaa voidaan lisätä": "Maksimalt 5 bilder kan legges til",
  "Haluatko varmasti poistaa kuvan?": "Er du sikker på at du vil slette bildet?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "Anbefalt bildeformat er 16:9, f.eks. 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Bildene vises i en bildekarusell",
  "Vastauksiin liitetään nimi automaattisesti": "Navn legges til svar automatisk",
  "Kyselyyn voi vastata useita kertoja": "Du kan svare på undersøkelsen flere ganger",
  "Vastaukset kerätään anonyymisti": "Svar samles inn anonymt",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Denne innstillingen kan ikke endres etter at undersøkelsen er besvart",
  "Salli useita vastauksia samalta käyttäjältä": "Tillat flere svar fra samme bruker",
  "Palautteiden käsittelijäksi voidaan...": "Merk: En administrator eller gruppeansvarlig kan velges som saksbehandler for tilbakemeldinger. Du kan legge til rettigheter for gruppeansvarlig i brukerens egne data under Brukere.",
  "Kaikki muutokset kirjataan lokiin": "Alle endringer gjort for saksbehandlere for tilbakemelding lagres i loggdataene. (Se loggen ved å klikke på ikonet til høyre.)",
  "Valitse käsittelyoikeudet": "Velg saksbehandlingsrettigheter",
  "Käsittelyoikeudet": "Saksbehandlingsrettigheter",
  "Tallennus onnistui": "Lagring vellykket",
  "Aikaleima": "Tidsstempel",
  "Suorittanut": "Utført av",
  "Kohdekäyttäjä": "Målbruker",
  "Tapahtuma": "Hendelse",
  "Loki": "Logg",
  "CategoryInfo": "Kategorisering av tilbakemeldinger er ikke aktivert. Opprett dine egne kategorier for ulike typer tilbakemeldinger ved å velge 'Ny tilbakemeldingstype' og skrive instruksjoner for tilbakemeldingstypen.",
  "Palautetyypit": "Tilbakemeldingstyper",
  "Palautetyypin nimi": "Navn på tilbakemeldingstype",
  "Valitse palautteen tyyppi": "Velg tilbakemeldingstype",
  "Otsikko on pakollinen kaikilla kielillä": "Tittel er obligatorisk på alle språk",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Instruksjon for innsender (f.eks. hvilken informasjon som skal legges til meldingen)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Kort beskrivelse (når tilbakemeldingstypen brukes)",
  "Uusi palautetyyppi": "Ny tilbakemeldingstype",
  "Palautteiden luokittelu": "Kategorisering av tilbakemeldinger",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Er du sikker på at du vil starte saksbehandling av tilbakemeldingen?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "Brukeren har lagt igjen kontaktinformasjon for oppfølging",
  "Palaute on käsitelty": "Tilbakemeldingen er behandlet",
  "Palauteilmoitukset": "Saksbehandlere for tilbakemelding",
  "Kirjoita viesti": "Skriv melding",
  "Sinä": "Du",
  "Voit lähettää yhden viestin vastauksena": "Du kan sende én melding som svar",
  "Haluatko varmasti lähettää viestin?": "Er du sikker på at du vil sende meldingen?",
  "Palautteet": "Tilbakemeldinger",
  "Näytä lähetetyt palautteet": "Vis sendte tilbakemeldinger",
  "Piilota lähetetyt palautteet": "Skjul sendte tilbakemeldinger",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Ønsker du å oppgi kontaktinformasjon for et personlig svar?",
  "Käsitelty": "Behandlet",
  "Avoin": "Åpen",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Du kan sende en melding eller et svar til innsenderen etter at tilbakemeldingen er tatt til behandling",
  "Tietoja": "Informasjon",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "Innsenderen av tilbakemeldingen kan svare på meldingen eller meldingene dine frem til tilbakemeldingen er markert som ferdigbehandlet.",
  "Käyttäjä": "Bruker",
  "Yhteystiedot": "Kontaktinformasjon",
  "Viestit": "Meldinger",
  "Käyttäjä ei ole jättänyt yhteystietoja": "Brukeren har ikke oppgitt kontaktinformasjon",
  "Lähetä lisäkysymys tai vastus": "Send oppfølgingsspørsmål eller svar",
  "Vie vastaukset": "Eksporter svar",
  "Päivitykset": "Oppdateringer",
  "Kutsu uudet käyttäjät": "Inviter nye brukere",
  "Lisää uusi palautteiden käsittelijä": "Legg til ny saksbehandler for tilbakemeldinger",
  "Ilmoitus sähköpostiin": "E-postvarsel",
  "Push-viesti puhelimeen": "Push-varsel til telefon",
  "Kutsu käyttäjiä": "Inviter brukere",
  "Käytä viestipohjaa": "Bruk meldingsmal",
  "Kutsuohje": "Meldingen nedenfor sendes som SMS til de valgte brukerne. Du kan redigere meldingen før den sendes hvis du ønsker det.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Kontroller at brukernes telefonnumre er korrekte før du sender meldingen.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Fant ingen uinviterte brukere",
  "Kutsu valitut käyttäjät": "Inviter valgte brukere",
  "Lähetys käynnissä, odota...": "Sending pågår, vennligst vent...",
  "Lähetys on valmis": "Sendingen er ferdig",
  "Kutsu käyttäjälle": "Invitasjon til bruker",
  "numeroon": "til nummer",
  "epäonnistui": "mislyktes",
  "Päivitä lista": "Oppdater liste",
  "Viesti on pakollinen": "Melding er obligatorisk",
  "Kirjoita vastaus": "Skriv svar",
  "Vastauksia": "Svar",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "Filformatet støttes ikke. Støttede filformater er ",
  "Liitetiedosto": "Vedleggsfil",
  "Halutessasi voi liittää liitetiedoston": "Du kan legge ved en fil hvis du ønsker det",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Du kan legge ved et bilde eller en PDF-fil hvis du ønsker det",
  "Liite": "Vedlegg",
  "Ladataan...": "Laster inn...",
  "Vastausaika on päättynyt": "Svartiden er utløpt",
  "Ei ilmoittautumisia": "Ingen påmeldinger",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "Du kan sende meldingen med Ctrl + Enter",
  "Omat keskustelut": "Mine samtaler",
  "Näytä keskustelukanavat": "Vis diskusjonskanaler",
  "Yksityinen kanava": "Privat kanal",
  "Hallinnoit tätä kanavaa": "Du administrerer denne kanalen",
  "Aloita uusi keskustelu": "Start en ny samtale",
  "Miten palautteet käsitellään": "Hvordan tilbakemeldinger behandles",
  "Haku": "Søk",
  "Omat tiedot ja asetukset": "Mine data og innstillinger",
  "Julkaisuaika on pakollinen": "Publiseringstidspunkt er obligatorisk",
  "Kuvaus...": "Beskrivelse...",
  "Saapunut ...": "Mottatt ...",
  "Nimi puuttuu": "Navn mangler",
  "Haluatko varmasti poistaa tapahtuman?": "Er du sikker på at du vil slette arrangementet?",
  "Ylläpito": "Vedlikehold",
  "Etusivu": "Forside",
  "Hallinta": "Administrasjon",
  "Muut": "Mer",
  "Omat tiedot": "Mine data",
  "Kirjaudu ulos": "Logg ut",
  "Lähetä": "Send",
  "Olet vastannut kyselyyn": "Du har besvart undersøkelsen",
  "Kyselyt": "Undersøkelser",
  "Vastausaika päättyy": "Svartiden utløper",
  "Ei kyselyjä": "Ingen undersøkelser",
  "Uusi tiedosto lisätty": "Ny fil lagt til",
  "Yritys": "Selskap",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Dra bildet hit eller klikk her for å velge bilde fra filer.",
  "Kuponki": "Kupong",
  "Otsikko": "Tittel",
  "Kuvaus": "Beskrivelse",
  "Etu julkaistaan heti": "Fordelen publiseres umiddelbart",
  "Etu tallennetaan luonnoksena": "Fordelen lagres som kladd",
  "Julkaise": "Publiser",
  "Tarkista lomakkeen tiedot": "Kontroller skjemadata",
  "Poista": "Slett",
  "Tallenna": "Lagre",
  "Tallenna lisätieto": "Lagre tilleggsinformasjon",
  "Henkilöstöedut": "Personalfordeler",
  "Uusi etu": "Ny fordel",
  "Julkaistu": "Publisert",
  "Keskustelukanavat": "Diskusjonskanaler",
  "Nimi": "Navn",
  "Kuva": "Bilde",
  "Kanavan tyyppi": "Kanalkategori",
  "Yksityinen keskustelu": "Privat samtale",
  "Ryhmäkeskustelu": "Gruppesamtale",
  "Kanavaa hallinnoivat": "Kanalansvarlige",
  "Käytössä": "I bruk",
  "Kanava on käytössä": "Kanalen er i bruk",
  "Kanava ei ole käytössä": "Kanalen er ikke i bruk",
  "Uusi kanava": "Ny kanal",
  "Aktiivinen": "Aktiv",
  "Klo": "Kl.",
  "klo": "kl.",
  "Ilmoittautuminen päättyy": "Påmeldingsfristen utløper",
  "Ilmoittautumiset": "Påmeldinger",
  "#": "#",
  "Henkilö": "Person",
  "Ilmoitautumisaika": "Påmeldingstid",
  "Kommentti": "Kommentar",
  "Tapahtumat": "Arrangementer",
  "Julkaise ryhmään": "Publiser til gruppe",
  "Tapahtuman alkuaika": "Starttid for arrangement",
  "Tapahtuman päättymisaika": "Sluttid for arrangement",
  "Palauteasetukset": "Innstillinger for tilbakemelding",
  "Ilmoittautuminen": "Påmelding",
  "Kommentti ilmoittautumisen yhteydessä": "Kommentar ved påmelding",
  "Tapahtuma julkaistaan heti": "Arrangementet publiseres umiddelbart",
  "Tapahtuma tallennetaan luonnoksena": "Arrangementet lagres som kladd",
  "Ryhmä on pakollinen": "Gruppe er obligatorisk",
  "Otsikko ja teksti on pakollinen": "Tittel og tekst er obligatorisk",
  "Alkuaika on pakollinen": "Starttid er obligatorisk",
  "Tarkista päättymisaika": "Kontroller sluttid",
  "Tarkista ilmoittautumisen päättymisaika": "Kontroller påmeldingsfrist",
  "Otsikko tai teksti puuttuu": "Tittel eller tekst mangler",
  "Uusi tapahtuma": "Nytt arrangement",
  "Aika": "Tid",
  "Ryhmä": "Gruppe",
  "Kysymykset & vastaukset": "Spørsmål og svar",
  "Kysymys": "Spørsmål",
  "Uusi kysymys": "Nytt spørsmål",
  "Saapunut": "Mottatt",
  "päivää sitten": "dager siden",
  "Käsittelyssä": "Under behandling",
  "Otettu käsittelyyn": "Tatt til behandling",
  "Valmis": "Ferdig",
  "Palaute": "Tilbakemelding",
  "Käyttäjä toivoo vastausta": "Brukeren ønsker svar",
  "Käyttäjä ei toivo vastausta": "Brukeren ønsker ikke svar",
  "Käsittely": "Behandling",
  "Ota käsittelyyn": "Ta til behandling",
  "Sisäinen lisätieto": "Intern tilleggsinformasjon",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Intern tilleggsinformasjon er ikke synlig for innsenderen",
  "Kuittaa käsitellyksi": "Marker som ferdigbehandlet",
  "Palautekanava": "Tilbakemeldingskanal",
  "SUODATA": "FILTRER",
  "Saapuneet": "Innboks",
  "Käsittely kesken": "Under behandling",
  "Valmiit": "Ferdige",
  "Saapunut tänään": "Mottatt i dag",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Klikk eller dra bilde hit for å legge til",
  "Julkaisuaika": "Publiseringstidspunkt",
  "Liitteet": "Vedlegg",
  "Lisää uusi liitetiedosto": "Legg til ny vedleggsfil",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Du kan legge til vedlegg på siden etter lagring",
  "Video": "Video",
  "Lisää uutiseen video": "Legg til video i nyheten",
  "Kysely": "Undersøkelse",
  "Lisää julkaisuun kysymys": "Legg til spørsmål i innlegget",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "Undersøkelsen er besvart og spørsmålene kan ikke lenger redigeres",
  "Kysymykset": "Spørsmål",
  "Uusi monivalintakysymys": "Nytt flervalgsspørsmål",
  "Uusi avoin kysymys": "Nytt åpent spørsmål",
  "Kirjoita kysymys": "Skriv spørsmål",
  "Lisää vastausvaihtoehto": "Legg til svaralternativ",
  "Kirjoita vastausvaihtoehto": "Skriv svaralternativ",
  "Uutinen julkaistaan julkaisaikana": "Nyheten publiseres på publiseringstidspunktet",
  "Uutinen tallennetaan luonnoksena": "Nyheten lagres som kladd",
  "Uutiset": "Nyheter",
  "Uusi uutinen": "Ny nyhet",
  "Näytä vastaukset": "Vis svar",
  "Julkaisupäivä": "Publiseringsdato",
  "Meidän yritys": "Vårt selskap",
  "Valitse kuva": "Velg bilde",
  "Lisää sivulle video": "Legg til video på siden",
  "Vimeo videon id": "Vimeo video ID",
  "Sivu julkaistaan heti": "Siden publiseres umiddelbart",
  "Sivu tallennetaan luonnoksena": "Siden lagres som kladd",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "Filformatet støttes ikke. Støttede filformater er JPEG og PNG.",
  "Uusi sivu": "Ny side",
  "Lisää alasivu": "Legg til underside",
  "Yhteenveto": "Sammendrag",
  "Vastaukset": "Svar",
  "Vastausaika": "Svartid",
  "Otsikko ja kuvaus on pakollinen": "Tittel og beskrivelse er obligatorisk",
  "Päivämäärä on pakollinen": "Dato er obligatorisk",
  "Kyselyssä ei ole yhtään kysymystä": "Undersøkelsen inneholder ingen spørsmål",
  "Tarkista kysymykset": "Kontroller spørsmålene",
  "Otsikko tai kuvaus puuttuu": "Tittel eller beskrivelse mangler",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Er du sikker på at du vil slette undersøkelsen og alle svarene?",
  "Uusi kysely": "Ny undersøkelse",
  "Tiedosto": "Fil",
  "Linkki": "Lenke",
  "Valitse uusi tiedosto": "Velg ny fil",
  "Tämä tieto on pakollinen": "Dette feltet er obligatorisk",
  "Max 500 merkkiä": "Maks 500 tegn",
  "Tiedosto julkaistaan heti": "Filen publiseres umiddelbart",
  "Tiedosto tallennetaan luonnoksena": "Filen lagres som kladd",
  "Tiedosto puuttuu": "Fil mangler",
  "Linkki puuttuu": "Lenke mangler",
  "Tiedostot": "Filer",
  "Uusi tiedosto": "Ny fil",
  "Avaa": "Åpne",
  "Tyyppi": "Type",
  "Miten palautteet käsitellään": "Hvordan tilbakemeldinger behandles",
  "Asetukset": "Innstillinger",
  "Palautteiden käsittelykäytäntö": "Retningslinjer for behandling av tilbakemeldinger",
  "Käyttäjät": "Brukere",
  "Etunimi": "Fornavn",
  "Sukunimi": "Etternavn",
  "Puhelin": "Telefon",
  "Sähköposti": "E-post",
  "Työtehtävä": "Tittel",
  "Näytä sähköposti kaikille": "Vis e-post til alle",
  "Näytä puhelinnumero kaikille": "Vis telefonnummer til alle",
  "Ryhmät": "Grupper",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "Brukeren er selskapets administrator og har rettigheter til å publisere i alle grupper",
  "Ryhmän ylläpitäjä": "Gruppeansvarlig",
  "Suodata": "Filtrer",
  "Uusi käyttäjä": "Ny bruker",
  "Näytä ryhmän ylläpitäjät": "Vis gruppeansvarlige",
  "Sähköposti": "E-post",
  "Kaikki käyttäjät": "Alle brukere",
  "Yrityksen pääkäyttäjät": "Selskapets administratorer",
  "Näytä kuponki": "Vis kupong",
  "Sulje": "Lukk",
  "Kirjoita viestisi": "Skriv meldingen din",
  "Aloita keskustelu": "Start samtale",
  "Yksityiset keskustelut": "Private samtaler",
  "Ei kanavia": "Ingen kanaler",
  "Ryhmäkeskustelut": "Gruppesamtaler",
  "Keskustelut": "Samtaler",
  "Viesti poistettu": "Melding slettet",
  "Poista viesti": "Slett melding",
  "Olet ilmoittautunut tapahtumaan": "Du er påmeldt arrangementet",
  "Peru ilmoittautuminen": "Avmeld",
  "Et ole ilmoittautunut tapahtumaan": "Du er ikke påmeldt arrangementet",
  "Ilmoittaudu mukaan": "Meld på",
  "Jätä palaute tai kysymys": "Legg igjen tilbakemelding eller spørsmål",
  "Kiitos, viesti lähetetty": "Takk, meldingen er sendt",
  "Kirjoita palaute tai kysymys": "Skriv tilbakemelding eller spørsmål",
  "Haluan henkilökohtaisen vastauksen": "Jeg ønsker et personlig svar",
  "Anna sähköposti tai puhelinnumero": "Oppgi e-post eller telefonnummer",
  "Miten palautteet käsitellään?": "Hvordan behandles tilbakemeldinger?",
  "Anna sähköpostiosoite tai puhelinnumero": "Oppgi e-postadresse eller telefonnummer",
  "Tervetuloa Piiriin": "Velkommen til Piiri",
  "Käyttäjätunnus tai puhelinnumero": "Brukernavn eller telefonnummer",
  "Jatka": "Fortsett",
  "Salasana": "Passord",
  "Kirjaudu sisään": "Logg inn",
  "Pin koodi": "PIN-kode",
  "Pin koodin saapumisessa voi kestää hetken.": "Det kan ta et øyeblikk før PIN-koden kommer.",
  "Kirjautuminen epäonnistui": "Innlogging mislyktes",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Innlogging mislyktes, kontroller PIN-koden",
  "Kirjaudutaan ulos...": "Logger ut...",
  "Uusimmat": "Siste",
  "Meillä töissä": "Hos oss",
  "Piiri-artikkelit": "Piiri-artikler",
  "Omat tiedot & asetukset": "Mine data og innstillinger",
  "Tietoa Piiri-sovelluksesta": "Informasjon om Piiri-appen",
  "Mikä on Piiri Kit?": "Hva er Piiri Kit?",
  "Tietosuojaseloste": "Personvernerklæring",
  "Töissä": "På jobb",
  "Poissa töistä": "Ikke på jobb",
  "Anna avainsana kaikilla kielillä.": "Oppgi nøkkelord på alle språk.",
  "Avainsana": "Nøkkelord",
  "Haluatko varmasti poistaa avainsanan?": "Er du sikker på at du vil slette nøkkelordet?",
  "Muokkaa avainsanaa": "Rediger nøkkelord",
  "Luo uusi avainsana": "Opprett nytt nøkkelord",
  "Avainsanat": "Nøkkelord",
  "Hae avainsanoja tai lisää uusi": "Søk etter nøkkelord eller legg til nytt",
  "Paina Enter luodaksesi uuden avainsanan": "Trykk Enter for å opprette nytt nøkkelord",
  "Avainsanojen hallinta": "Administrasjon av nøkkelord",
  "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "Vi fornyer våre undersøkelser. Du kan prøve det nye verktøyet",
  "tästä": "her",
  "Kyselyn vastaukset": "Svar på undersøkelse",
  "Viimeisin vastaus": "Siste svar",
  "Näytetään": "Viser",
  "Kyselyä ei löytynyt": "Fant ikke undersøkelsen",
  "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "Du får PIN-koden via SMS hvis telefonnummeret ditt er i systemet vårt. Skriv det inn nedenfor.",
  "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "Hvis du ikke mottok PIN-koden, sjekk at du skrev inn telefonnummeret ditt riktig.",
  "Kirjoita hakusana": "Skriv et søkeord",
  "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "Søkeordet må være minst 3 tegn langt"
}
